import { render, staticRenderFns } from "./sobreMi.vue?vue&type=template&id=00a5d80d&scoped=true&"
var script = {}
import style0 from "./sobreMi.vue?vue&type=style&index=0&id=00a5d80d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5d80d",
  null
  
)

export default component.exports